let currentArtist = null;
let clockInterval = null;
let klydoModalChimeAudio = null;
let currentKlydoInModal = null;

const KLYDO_MODAL_URL_PARAM = "klydoId";

const getKlydoId = (klydo) => klydo?._id || klydo?.id || "";

const buildKlydoShareUrl = (klydo) => {
  const url = new URL(window.location.href);
  const klydoId = getKlydoId(klydo);
  if (klydoId) url.searchParams.set(KLYDO_MODAL_URL_PARAM, klydoId);
  return url.toString();
};

function openKlydoModalFromUrlIfPresent(klydos) {
  const urlKlydoId = new URLSearchParams(window.location.search).get(
    KLYDO_MODAL_URL_PARAM,
  );
  if (!urlKlydoId) return;
  const target = (klydos || []).find(
    (klydo) => getKlydoId(klydo) === urlKlydoId,
  );
  if (target) openKlydoModal(target);
}

const findFirstChimeUrl = (chimesUrls) => {
  if (!chimesUrls) return null;
  if (typeof chimesUrls === "string") return chimesUrls || null;
  const candidates = Array.isArray(chimesUrls)
    ? chimesUrls
    : Object.values(chimesUrls);
  return candidates.find((url) => typeof url === "string" && url) || null;
};

const stopKlydoModalChime = () => {
  if (!klydoModalChimeAudio) return;
  klydoModalChimeAudio.pause();
  klydoModalChimeAudio = null;
};

function updateClockHands() {
  const now = new Date();
  const hours = now.getHours() % 12;
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  const hourAngle = (hours + minutes / 60) * 30;
  const minuteAngle = (minutes + seconds / 60) * 6;

  const hourHand = document.getElementById("klydo-modal-hour");
  const minuteHand = document.getElementById("klydo-modal-minute");
  if (hourHand)
    hourHand.setAttribute("transform", "rotate(" + hourAngle + " 100 100)");
  if (minuteHand)
    minuteHand.setAttribute("transform", "rotate(" + minuteAngle + " 100 100)");
}

const syncSoundButtonIcons = (isMuted) => {
  const soundButton = document.getElementById("klydo-modal-sound");
  const speakerIcon = soundButton.querySelector(".klydo-modal__sound-icon--speaker");
  const muteIcon = soundButton.querySelector(".klydo-modal__sound-icon--mute");
  speakerIcon.style.display = isMuted ? "none" : "block";
  muteIcon.style.display = isMuted ? "block" : "none";
};

function openKlydoModal(klydo) {
  currentKlydoInModal = klydo;
  const modal = document.getElementById("klydo-modal");
  const nameEl = document.getElementById("klydo-modal-name");
  const clockEl = document.getElementById("klydo-modal-clock");
  const handsSvg = document.getElementById("klydo-modal-hands");
  const pendulumBob = document.getElementById("klydo-modal-pendulum-bob");
  const pendulumLogo = document.getElementById("klydo-modal-pendulum-logo");
  nameEl.textContent = klydo.name || "";
  clockEl.innerHTML = "";

  const mediaUrl = klydo.loopUrl || klydo.photoUrl || "";
  if (isVideo(mediaUrl)) {
    const video = document.createElement("video");
    video.src = getScaledCloudinaryUrl(mediaUrl, 800);
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    clockEl.appendChild(video);
  } else if (mediaUrl) {
    const img = document.createElement("img");
    img.src = getScaledCloudinaryUrl(mediaUrl, 800, "f_auto");
    img.alt = klydo.name || "";
    clockEl.appendChild(img);
  }

  const theme = klydo.theme || {};
  const handsColor = theme.handsColor || "#ffffff";

  handsSvg.style.display = "";
  document
    .getElementById("klydo-modal-hour")
    .setAttribute("stroke", handsColor);
  document
    .getElementById("klydo-modal-minute")
    .setAttribute("stroke", handsColor);
  updateClockHands();
  if (clockInterval) clearInterval(clockInterval);
  clockInterval = setInterval(updateClockHands, 1000);

  /* Pendulum */
  const backgroundColor = theme.backgroundColor || "#333";
  const pendulumColor = theme.pendulumColor || "#666";
  const rodColor = theme.pendulumRodColor || pendulumColor;
  const pendulumBg = document.getElementById("klydo-modal-pendulum-bg");
  const pendulumRod = document.getElementById("klydo-modal-pendulum-rod");
  pendulumBg.style.background = backgroundColor;
  pendulumRod.style.background = rodColor;
  pendulumBob.style.background = pendulumColor;

  if (klydo.pendulumLogo) {
    pendulumLogo.src = klydo.pendulumLogo;
    pendulumLogo.style.display = "";
  } else {
    pendulumLogo.style.display = "none";
  }

  const soundButton = document.getElementById("klydo-modal-sound");
  soundButton.disabled = !klydo.hasSound;
  syncSoundButtonIcons(true);

  const chimeButton = document.getElementById("klydo-modal-chime");
  const chimeUrl = findFirstChimeUrl(klydo.chimesUrls);
  chimeButton.disabled = !chimeUrl;
  chimeButton.dataset.chimeUrl = chimeUrl || "";
  stopKlydoModalChime();

  modal.classList.add("klydo-modal--open");
  document.body.style.overflow = "hidden";
}

function getKlydoModalVideo() {
  return document.getElementById("klydo-modal-clock").querySelector("video");
}

function closeKlydoModal() {
  const modal = document.getElementById("klydo-modal");
  modal.classList.remove("klydo-modal--open");
  document.body.style.overflow = "";
  const video = getKlydoModalVideo();
  if (video) video.pause();
  stopKlydoModalChime();
  if (clockInterval) {
    clearInterval(clockInterval);
    clockInterval = null;
  }
}

function setupKlydoModalCloseListeners() {
  document
    .getElementById("klydo-modal-close")
    .addEventListener("click", closeKlydoModal);
  document
    .getElementById("klydo-modal-backdrop")
    .addEventListener("click", closeKlydoModal);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeKlydoModal();
  });
}

function setupKlydoModalSoundButton() {
  const soundButton = document.getElementById("klydo-modal-sound");
  soundButton.addEventListener("click", () => {
    const video = getKlydoModalVideo();
    if (!video) return;
    video.muted = !video.muted;
    syncSoundButtonIcons(video.muted);
  });
}

function setupKlydoModalChimeButton() {
  const chimeButton = document.getElementById("klydo-modal-chime");
  chimeButton.addEventListener("click", () => {
    const chimeUrl = chimeButton.dataset.chimeUrl;
    if (!chimeUrl) return;
    stopKlydoModalChime();
    klydoModalChimeAudio = new Audio(chimeUrl);
    klydoModalChimeAudio.play().catch(() => {});
  });
}

function setupKlydoModalShareButton() {
  const shareButtonElement = document.getElementById("klydo-modal-share");
  shareButtonElement.addEventListener("click", () => {
    const shareUrl = buildKlydoShareUrl(currentKlydoInModal);
    if (navigator.share) {
      navigator.share({ title: document.title, url: shareUrl }).catch(() => {});
      return;
    }
    navigator.clipboard.writeText(shareUrl).then(() => {
      shareButtonElement.classList.add("klydo-modal__action-btn--copied");
      shareButtonElement.innerHTML =
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
      setTimeout(() => {
        shareButtonElement.classList.remove("klydo-modal__action-btn--copied");
        shareButtonElement.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
      }, 2000);
    });
  });
}

function initKlydoModalListeners() {
  setupKlydoModalCloseListeners();
  setupKlydoModalSoundButton();
  setupKlydoModalChimeButton();
  setupKlydoModalShareButton();
}
